<script>
  import Fa from "svelte-fa"
  import { faStar as emptyStar } from "@fortawesome/free-regular-svg-icons"
  import { faStar as solidStar } from "@fortawesome/free-solid-svg-icons"

  export let rating
  export let compact = false

  let hoverRating = rating

  let classes
  let hover_classes

  if (compact) {
    classes = "text-base justify-start"
    hover_classes = "hover:text-accent"
  } else {
    classes = "text-xl justify-center text-sapphire"
    hover_classes = "hover:text-sapphire"
  }

  function onOver(i) {
    if (compact) return
    hoverRating = i
  }

  function onLeave(i) {
    if (compact) return
    hoverRating = rating
  }

  function setRating(i) {
    if (compact) return
    rating = i
  }
</script>

<main class="flex items-center {classes}">
  {#each { length: 5 } as _, i}
    <div
      class="cursor-pointer {hover_classes} "
      on:mouseover={() => onOver(i + 1)}
      on:focus={() => onOver(i + 1)}
      on:mouseleave={() => onLeave(i + 1)}
      on:click={() => setRating(i + 1)}
    >
      {#if hoverRating > i}
        <Fa icon={solidStar} />
      {:else}
        <Fa icon={emptyStar} />
      {/if}
    </div>
  {/each}
</main>
